import { BasicLayout, BlankLayout } from '@/layout'

const goodsRouter = {
  path: '/goods',
  name: 'Goods',
  component: BasicLayout,
  redirect: 'noRedirect',
  meta: { title: '商品管理', icon: 'el-icon-s-goods', breadcrumb: false },
  children: [
    {
      path: 'gift',
      component: BlankLayout, // Parent router-view
      name: 'GiftPackage',
      meta: { title: '特权礼包管理' },
      redirect: '/goods/gift/list',
      children: [
        {
          path: 'list',
          name: 'GiftList',
          meta: { title: '特权礼包列表', keepAlive: true },
          component: () => import('@/views/goods/gift/list')
        },
        {
          path: 'create',
          name: 'CreateGiftPackage',
          meta: { title: '添加礼包商品', keepAlive: true },
          component: () => import('@/views/goods/gift/create')
        },
        {
          hidden: true,
          path: 'edit',
          name: 'EditGiftPackage',
          component: () => import('@/views/goods/gift/edit'),
          meta: { title: '编辑礼包商品', keepAlive: true, activeMenu: '/goods/gift/list' }
        }
      ]
    },
    {
      path: 'point',
      component: BlankLayout, // Parent router-view
      name: 'PointGoods',
      meta: { title: '积分商品管理' },
      redirect: '/goods/point/list',
      children: [
        {
          path: 'list',
          name: 'PointGoodList',
          meta: { title: '积分商品列表', keepAlive: true },
          component: () => import('@/views/goods/point/list')
        },
        {
          path: 'create',
          name: 'CreatePointGoods',
          meta: { title: '添加积分商品', keepAlive: true },
          component: () => import('@/views/goods/point/create')
        },
        {
          hidden: true,
          path: 'edit',
          name: 'EditPointGoods',
          component: () => import('@/views/goods/point/edit'),
          meta: { title: '编辑积分商品', keepAlive: true, activeMenu: '/goods/point/list' }
        }
      ]
    },
    {
      path: 'welfare',
      component: BlankLayout, // Parent router-view
      name: 'WelfareGoods',
      meta: { title: '福利商品管理' },
      redirect: '/goods/welfare/list',
      children: [
        {
          path: 'list',
          name: 'WelfareList',
          meta: { title: '福利商品列表', keepAlive: true },
          component: () => import('@/views/goods/welfare/list')
        },
        {
          path: 'create',
          name: 'CreateWelfare',
          meta: { title: '添加福利商品', keepAlive: true },
          component: () => import('@/views/goods/welfare/create')
        },
        {
          hidden: true,
          path: 'edit',
          name: 'EditWelfare',
          component: () => import('@/views/goods/welfare/edit'),
          meta: { title: '福利商品商品', keepAlive: true, activeMenu: '/goods/welfare/list' }
        }
      ]
    },
    {
      path: 'premium',
      component: BlankLayout, // Parent router-view
      name: 'PremiumProduct',
      meta: { title: '优品商品管理' },
      redirect: '/goods/premium/list',
      children: [
        {
          path: 'list',
          name: 'PremiumList',
          meta: { title: '优品商品列表', keepAlive: true },
          component: () => import('@/views/goods/premium/list')
        },
        {
          path: 'create',
          name: 'CreatePremium',
          meta: { title: '添加优品商品', keepAlive: true },
          component: () => import('@/views/goods/premium/create')
        },
        {
          hidden: true,
          path: 'edit',
          name: 'EditPremium',
          component: () => import('@/views/goods/premium/edit'),
          meta: { title: '编辑优品商品', keepAlive: true, activeMenu: '/goods/premium/list' }
        }
      ]
    },
    // {
    //   path: 'list',
    //   name: 'ProductList',
    //   meta: { title: '商品列表', keepAlive: true },
    //   component: () => import('@/views/goods/list')
    // },
    // {
    //   path: 'create',
    //   name: 'CreateProduct',
    //   meta: { title: '添加商品', keepAlive: true },
    //   component: () => import('@/views/goods/create')
    // },
    // {
    //   hidden: true,
    //   path: 'edit',
    //   name: 'EditProduct',
    //   component: () => import('@/views/goods/edit'),
    //   meta: { title: '编辑商品', keepAlive: true, activeMenu: '/goods/list' }
    // },
    {
      path: 'category',
      name: 'Category',
      component: () => import('@/views/goods/category/index'),
      meta: { title: '商品分类管理' }
    }
  ]
}

export default goodsRouter
